import { UserManager } from "oidc-client-ts";
import { from, map } from "rxjs";
import { getPolicies } from "./utils.js";
class UserManagerExtended extends UserManager {
  getUserObservable() {
    return from(this.getUser());
  }
  getUserExtended() {
    return this.getUserObservable().pipe(
      map((u) => {
        const res = u;
        res.authHeaders = this.getAuthHeadersFromUser(u);
        res.basicInfo = this.getUserBasicInfoFromUser(u);
        return res;
      })
    );
  }
  getSignInUrl() {
    const settings = {
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: this.settings.redirect_uri
    };
    return from(this._client.createSigninRequest(settings)).pipe(
      map((v) => {
        const url = new URL(v.url);
        return url.toString().substring(url.origin.length);
      })
    );
  }
  getPolicies() {
    return this.getUserObservable().pipe(map((user) => getPolicies(user)));
  }
  getUserBasicInfoFromUser(user) {
    return {
      permissions: getPolicies(user),
      uid: user?.profile?.sub
    };
  }
  getAuthHeadersFromUser(user) {
    const authorization = user ? `${user.token_type} ${user.access_token}` : null;
    const headers = {};
    if (authorization !== null) {
      headers.Authorization = authorization;
    }
    return headers;
  }
}
export {
  UserManagerExtended
};
//# sourceMappingURL=userManager.js.map
